import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Company {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.customerCompanySetting}?${params}`)
    }

    remove(id) {
        return BaseService.post(
            `${APIPath.customerCompanySetting}/Remove?SettingId=${id}`,
        )
    }

    add(data) {
        return BaseService.post(`${APIPath.customerCompanySetting}`, data)
    }

    update(data) {
        return BaseService.post(`${APIPath.updatecustomerCompanySetting}`, data)
    }

    getAuditCompanies(queryParams) {
        if (queryParams) {
            const params = CommonUtility.objectToParams(queryParams)
            return BaseService.get(`${APIPath.auditCompanies}?${params}`)
        }
        return BaseService.get(`${APIPath.auditCompanies}`)
    }

    getInspectionNameConfig(companyId) {
        return BaseService.get(APIPath.inspectionNameConfig(companyId))
    }

    updateInspectionNameConfig(companyId, data) {
        return BaseService.put(APIPath.inspectionNameConfig(companyId), data)
    }

    getPdfFilenameConfig(companyId) {
        return BaseService.get(APIPath.pdfFilenameConfig(companyId))
    }

    updatePdfFilenameConfig(companyId, data) {
        return BaseService.put(APIPath.pdfFilenameConfig(companyId), data)
    }
}

const CompanyService = new Company()
Object.freeze(CompanyService)
export { CompanyService }
